import React, { Fragment, useContext, useEffect, useRef, useState } from 'react';
import moment from 'moment';
import { AnyIfEmpty, useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import iconBack from '../../../images/icon-chevron-left.svg';
import SearchIcon from '../../../images/icon-search.svg';
import { AppDispatch, IRootState } from '../../../redux/rootReducer';
import { createVisitorAppointment, getUnit, resetCreateVisitorError } from '../../../redux/visitor-list/actions/createAppoinment.action';
import AppointmentConfirmation from '../../appointmentConfirmation/appointmentConfirmation';
import AppointmentDateTimePicker from '../../appointmentDateTimePicker/appointmentDateTimePicker';
import { SpecificLockersData } from '../../appointmentDateTimePicker/interface/appointmentDateTimePicker.interface';
import CustModal from '../../common/custmodal/CustModal';
import Loader from '../../common/loader/Loader';
import Toast from '../../common/toast/Toast';
import TinyLoader from '../../common/tiny-loader/TinyLoader';
import { AvailabilityData, AvailabilityRedirectionContext, UserTableData } from '../../context/availabilityRedirection';
import NoUnits from '../../../images/no-units-found.svg';
import { AppointmentProps, locationProps, UnitProps } from '../interface/Visitor.interface';
import { SelectedUserData } from '../selectedUserData/SelectedUserData';
import { SelectProperty } from '../selectProperty/SelectProperty';
import { SelectUser } from '../selectUser/SelectUser';
import AppointmentPopup from './appointmentPopup';
import styles from './visitorAppointment.module.css';
import toast from 'react-hot-toast';
import { useDebounce } from '../../../utils/useDebounce';
import { getAppointmentUnits } from '../../../redux/appointment-units/actions/appointmentUnits.action';
import Tooltip from '../../common/tooltip/Tooltip';
import KeyLockerIcon from '../../svgIcons/KeyLockerIcon';

function VisitorAppointment() {
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();
    const { error: AppoointmentError } = useSelector((state: IRootState) => state.createAppoinmentReducer.createVisitor);

    const availabilityRedirectionContext = useContext(AvailabilityRedirectionContext);
    const [showSearchResult, setShowSearchResult] = useState(false);
    const [selectedUser, setSelectedUser] = useState('');
    const [upperContainerHeight, setUpperContainerHeight] = useState(0);
    const [pageHeight, setPageHeight] = useState(0);
    const [selectedProperty, setSelectedProperty] = useState('');
    const [appointmentStep, setAppointmentStep] = useState(1);
    const [selectedUnit, setSelectedUnit] = useState('');
    const [enable, setEnable] = useState(false);
    const [locationDetail, setLocationdetail]: AnyIfEmpty<object> = useState({});
    const [selectedDate, setSelectedDate] = useState(new Date(moment().format()));
    const [showModalPopup, setShowModalPopup] = useState(false);
    const [specificLockerData, setSpecificLockerData] = useState<SpecificLockersData[]>([]);
    const [searchUnits, setSearchUnits] = useState('');
    const [selectedUnitName, setSelectedUnitName] = useState('');
    const searchWithDebounce = useDebounce(searchUnits, 1000);
    const previousSearchRef = useRef<string>('');
    const [activeTab, setActiveTab] = useState(0);
    const [selectedSlots, setSelectedSlots] = useState<number[]>([]);
    const [userData, setUserData] = useState<UserTableData>({
        name: '',
        email: '',
        contact: '',
        date: '',
        bedrooms: '',
        countryCode: 0,
        locationName: '',
        companyName: '',
    });
    const [userId, setUserId] = useState('');
    const [slotRange, setSlotRange] = useState('');
    const [unitInfo, setUnitInfo] = useState<any[]>([]);
    const [searchText, setSearchText] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const observer = useRef<IntersectionObserver | null>(null);
    const lastElementRef = useRef<HTMLTableRowElement>(null);

    const { data: createVisitor, loading, error: createVisitorError } = useSelector((state: IRootState) => state.createAppoinmentReducer.createVisitor);
    const { data } = useSelector((state: IRootState) => state.createAppoinmentReducer.unit);

    const { data: unitsData, count, loading: unitsLoading, error: unitsError } = useSelector(
        (state: IRootState) => state.appointmentUnits
    );


    useEffect(() => {
        if (Object.keys(createVisitor).length && createVisitor.statusCode === 201) {
            setShowModalPopup(true);
        }
    }, [createVisitor]);

    useEffect(() => {
        // Only process if we have actual data from Redux
        if (!unitsData || unitsData.length === 0) {
            // Clear unitInfo only on first page when data is empty
            if (currentPage === 1) {
                setUnitInfo([]);
            }
            setHasMore(false);
            return;
        }

        // Process and update unitInfo based on current page
        if (currentPage === 1) {
            // First page: replace data completely
            setUnitInfo(unitsData);
            setHasMore(unitsData.length > 0 && unitsData.length < count);
        } else {
            // Subsequent pages: append and deduplicate
            setUnitInfo((prev) => {
                const existingIds = new Set(prev.map((item: any) => item.id));
                const newItems = unitsData.filter((item: any) => !existingIds.has(item.id));
                const merged = [...prev, ...newItems];

                // Update hasMore based on merged length vs count
                if (count > 0 && merged.length >= count) {
                    setHasMore(false);
                } else {
                    setHasMore(true);
                }

                return merged;
            });
        }
    }, [unitsData, currentPage, count]);


    // Reset pagination and clear data when locationId or search changes
    useEffect(() => {
        const locationId = availabilityRedirectionContext?.availabilityData.locationId;
        const searchChanged = previousSearchRef.current !== searchWithDebounce;

        if (locationId) {
            if (searchChanged || previousSearchRef.current === '') {
                // Clear data immediately when search changes
                setUnitInfo([]);
                setCurrentPage(1);
                setHasMore(true);
            }
            // Update ref to track current search
            previousSearchRef.current = searchWithDebounce;
        }
    }, [availabilityRedirectionContext?.availabilityData.locationId, searchWithDebounce]);

    // Fetch units with pagination
    useEffect(() => {
        const locationId = availabilityRedirectionContext?.availabilityData.locationId;
        if (locationId && currentPage) {
            dispatch(getAppointmentUnits(locationId, {
                searchText: searchWithDebounce || undefined,
                statusFilter: 'available',
                page: currentPage,
                limit: 12,
            }));
        }
    }, [availabilityRedirectionContext?.availabilityData.locationId, currentPage, searchWithDebounce, dispatch]);

    // useEffect(() => {
    //     if (createVisitorError) {
    //         toast.error(createVisitorError || "Appointment Creation Failed");

    //         setTimeout(() => {
    //             dispatch(resetCreateVisitorError())
    //         }, 4000)
    //     }
    // }, [createVisitorError]);

    useEffect(() => {
        if (availabilityRedirectionContext?.step === 4) {
            setAppointmentStep(availabilityRedirectionContext.step);
            setEnable(true);
        } else if (
            availabilityRedirectionContext?.step === 3 &&
            availabilityRedirectionContext.availabilityData.lockerNumber &&
            availabilityRedirectionContext.availabilityData.selectedDate
        ) {
            setAppointmentStep(availabilityRedirectionContext.step);
            setActiveTab(availabilityRedirectionContext.availabilityData.lockerNumber - 1);
            setSelectedDate(new Date(moment(availabilityRedirectionContext.availabilityData.selectedDate).format()));
            setSelectedSlots(availabilityRedirectionContext?.selectedSlotsIndex);
        }
    }, [availabilityRedirectionContext]);

    useEffect(() => {
        if (availabilityRedirectionContext?.availabilityData.unitId) {
            dispatch(getUnit(availabilityRedirectionContext?.availabilityData.unitId));
        }
    }, [availabilityRedirectionContext?.availabilityData.unitId]);

    useEffect(() => {
        setSearchUnits('');
    }, [locationDetail]);

    // Infinite scroll observer
    useEffect(() => {
        const node = lastElementRef.current;
        if (!node || unitsLoading || !hasMore) {
            if (observer.current) {
                observer.current.disconnect();
            }
            return;
        }

        if (observer.current) {
            observer.current.disconnect();
        }

        observer.current = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting && hasMore && !unitsLoading) {
                    setCurrentPage((prev) => prev + 1);
                }
            },
            { threshold: 0.1 } // Changed from 1.0 to 0.1 for better triggering
        );

        observer.current.observe(node);

        return () => {
            if (observer.current) {
                observer.current.disconnect();
            }
        };
    }, [unitsLoading, hasMore, unitInfo.length]);

    const getMeasure = () => {
        const height = document.getElementsByClassName('upperContainer')[0];
        const pageHeight = window?.innerHeight;
        setPageHeight(pageHeight);
        setUpperContainerHeight(height?.clientHeight);
    };

    useEffect(() => {
        getMeasure();
        window.addEventListener('resize', getMeasure);
    }, [0]);

    const handleBackButton = () => {
        if (appointmentStep !== 1) {
            setAppointmentStep(appointmentStep - 1);
            availabilityRedirectionContext?.setStep(appointmentStep - 1);
        } else {
            setAppointmentStep(1);
            availabilityRedirectionContext?.setStep(1);
        }
        if (appointmentStep === 2 && availabilityRedirectionContext) {
            setAppointmentStep(1);
            setSelectedUser(availabilityRedirectionContext.selectedUserTableData.name);
            // setSearchText(availabilityRedirectionContext.selectedUserTableData.name);
            setUserData(availabilityRedirectionContext.selectedUserTableData);
        }
        if (appointmentStep === 4 && availabilityRedirectionContext?.availabilityData.selectedDate) {
            setSelectedDate(new Date(moment(availabilityRedirectionContext.availabilityData.selectedDate).format()));
            setActiveTab(availabilityRedirectionContext.availabilityData.lockerNumber - 1);
            setSelectedSlots(selectedSlots);
            availabilityRedirectionContext.setSelectedSlotsIndex(selectedSlots);
        }
    };

    const handleNext = () => {
        const currentSelectedDate = moment(selectedDate).format('YYYY-MM-DD');
        const availabilityObject: AvailabilityData = {
            locationId: locationDetail?.id ? locationDetail.id : availabilityRedirectionContext?.availabilityData.locationId,
            unitId: selectedUnit ? selectedUnit : availabilityRedirectionContext?.availabilityData.unitId || '',
            selectedDate: currentSelectedDate,
            slotRange: slotRange,
            locationName: locationDetail?.name ? locationDetail?.name : availabilityRedirectionContext?.availabilityData.locationName,
            unitName: selectedUnitName ? selectedUnitName : availabilityRedirectionContext?.availabilityData.unitName || '',
            lockerNumber: activeTab + 1,
        };

        let isBetweenAvailabilityDateRange = false;

        data?.availabilities?.forEach((availability: { startDate: string; endDate: string; locker: number }) => {
            if (isBetweenAvailabilityDateRange) {
                return;
            }

            const { startDate, endDate, locker } = availability;

            isBetweenAvailabilityDateRange =
                moment(currentSelectedDate).isBetween(startDate, endDate, undefined, '[]') && (availabilityRedirectionContext?.locationDetails?.lockerName?.toLowerCase() === 'kiosk' ? (locker === activeTab + 1) ? true : false : true);
        });

        if (isBetweenAvailabilityDateRange) {
            setAppointmentStep(appointmentStep + 1);
            availabilityRedirectionContext?.setStep(appointmentStep + 1);
            availabilityRedirectionContext?.setAvailabilityData(availabilityObject);
        } else {
            availabilityRedirectionContext?.setAvailabilityData(availabilityObject);
            availabilityRedirectionContext?.setSelectedSlotsIndex(selectedSlots);
            navigate('/visits');
        }
    };

    const handleConfirm = async () => {
        const currentSelectedDate = moment(
            availabilityRedirectionContext?.availabilityData.selectedDate
                ? availabilityRedirectionContext?.availabilityData.selectedDate
                : selectedDate,
        ).format('YYYY-MM-DD');

        const [startTime, endTime] = (slotRange || availabilityRedirectionContext?.availabilityData?.slotRange)?.split(' - ') || [];

        const appointment: AppointmentProps = {
            reservedDate: currentSelectedDate,
            start_time: startTime,
            end_time: (endTime === "12:00 AM" || endTime === "12 AM") ? "11:59 PM" : endTime,
            availabilityId: data?.availabilities[0].id,
            timestamp: Date.now()
        };

        if (availabilityRedirectionContext?.locationDetails?.lockerName?.toLowerCase() === 'kiosk') {
            try {
                const lockerWiseAvailability: { openTime: string; closeTime: string; id: string; availability: string[] }[] = await
                    data?.availabilities?.filter((availability: { locker: number; startDate: string; endDate: string }) => {
                        const { startDate, endDate } = availability;

                        return (
                            availability.locker ===
                            (availabilityRedirectionContext?.availabilityData.lockerNumber
                                ? availabilityRedirectionContext?.availabilityData.lockerNumber
                                : activeTab + 1) && moment(currentSelectedDate).isBetween(startDate, endDate, undefined, '[]')
                        );
                    });

                const availabilityRangeWiseLockerId = await lockerWiseAvailability.reduce((availability: string[], { openTime, closeTime, id }) => {
                    let sTime = moment(startTime, "h:mm A");
                    let eTime = moment(endTime, "h:mm A");

                    // FIX midnight: 12 AM becomes 23:59
                    if (endTime === "12:00 AM" || endTime === "12 AM") {
                        eTime = moment("23:59", "HH:mm");
                    }

                    // If end time is technically next day (crossing midnight)
                    if (eTime.isBefore(sTime)) {
                        eTime.add(1, "day");
                    }

                    // Normalize close time (00:00 → 23:59)
                    const normalizedCloseTime = closeTime === "00:00" ? "23:59" : closeTime;

                    let open = moment(openTime, "HH:mm");
                    let close = moment(normalizedCloseTime, "HH:mm");

                    // If close time is next-day (example: 23:00 → 01:00)
                    if (close.isBefore(open)) {
                        close.add(1, "day");
                    }

                    const isStartTimeWithinRange = moment(sTime).isBetween(open, close, undefined, "[]");
                    const isEndTimeWithinRange = eTime.isBetween(open, close, undefined, "[]");

                    if (isStartTimeWithinRange && isEndTimeWithinRange) {
                        availability.push(id);
                    }
                    return availability;
                }, []);

                appointment.availabilityId = await availabilityRangeWiseLockerId[0];
            } catch (error) {
                console.error('Error processing kiosk locker availability:', error);
            }
        }


        dispatch(
            createVisitorAppointment(
                userId ? userId : availabilityRedirectionContext?.userId,
                appointment,
                availabilityRedirectionContext?.setStep,
                availabilityRedirectionContext?.setAvailabilityData,
                availabilityRedirectionContext?.setData,
                availabilityRedirectionContext?.setLocationDetails,
                availabilityRedirectionContext?.setSelectedUserTableData,
                availabilityRedirectionContext?.setUserId,
            ),
        );
    };

    const onClickHandler = (location: locationProps) => {
        setLocationdetail(location);
        availabilityRedirectionContext?.setLocationDetails(location);
        // Set locationId and locationName in availabilityData
        availabilityRedirectionContext?.setAvailabilityData((prevState: any) => ({
            ...prevState,
            locationId: location.id,
            locationName: location.name || '',
        }));
        setEnable(true);
    };

    return loading ? (
        <Loader />
    ) : (
        <Fragment>
            {createVisitorError && <Toast message={createVisitorError} />}
            <div className="upperContainer">
                <div className={styles.inlineItems}>
                    <div className={styles.leftSection}>
                        <div
                            className={styles.backButton}
                            onClick={() => {
                                appointmentStep === 1 ? navigate('/visitor') : handleBackButton();
                                // setSearchText(
                                //     availabilityRedirectionContext && availabilityRedirectionContext?.selectedUserTableData.name
                                //         ? availabilityRedirectionContext.selectedUserTableData.name
                                //         : searchText,
                                // );
                            }}>
                            <img src={iconBack} alt="back icon" />
                        </div>

                        <h2>Create Appointment</h2>
                    </div>

                    {appointmentStep > 2 && (
                        <button className={styles.btnGreen} onClick={appointmentStep !== 4 ? handleNext : handleConfirm} disabled={!enable}>
                            {appointmentStep === 3 ? 'Next' : appointmentStep === 4 && 'Confirm'}
                        </button>
                    )}
                </div>

                {appointmentStep === 1 && (
                    <SelectUser
                        setSelectedUser={setSelectedUser}
                        setShowSearchResult={setShowSearchResult}
                        setUserData={setUserData}
                        showSearchResult={showSearchResult}
                        setUserId={setUserId}
                        searchText={searchText}
                        setSearchText={setSearchText}
                    />
                )}
            </div>

            {appointmentStep === 1 ? (
                selectedUser === '' ? (
                    <div className={styles.selectUserContainer} style={{ height: pageHeight - upperContainerHeight - 32 - 125 }}>
                        <div className={styles.innerContainer}>
                            <h2>You need to select a User</h2>

                            <p>Kindly select the user from above search bar to book an appointment</p>
                        </div>
                    </div>
                ) : (
                    <Fragment>
                        <SelectedUserData userData={userData} />

                        <SelectProperty
                            setSelectedProperty={setSelectedProperty}
                            onClickHandler={onClickHandler}
                            setAppointmentStep={setAppointmentStep}
                            appointmentStep={appointmentStep}
                        />
                    </Fragment>
                )
            ) : appointmentStep === 2 ? (
                <Fragment>
                    <div className={styles.inlineSearch}>
                        <h2>
                            Select Unit For{' '}
                            {availabilityRedirectionContext?.availabilityData.locationName
                                ? availabilityRedirectionContext?.availabilityData.locationName
                                : locationDetail?.name}
                        </h2>

                        <div className={styles.searchBox}>
                            <input
                                value={searchUnits}
                                onChange={(e) => setSearchUnits(e.target.value)}
                                type="text"
                                placeholder="Search for Unit"
                                maxLength={50}
                            />

                            <img className={styles.searchIconImage} src={SearchIcon} alt="search-icon" />
                        </div>
                    </div>

                    {/* Commented out UnitListing component - replaced with table view */}
                    {/* <UnitListing
                        setEnable={setEnable}
                        setSelectedUnit={setSelectedUnit}
                        unitInfo={unitInfo}
                        setAppointmentStep={setAppointmentStep}
                        appointmentStep={appointmentStep}
                        selectedProperty={selectedProperty}
                        searchUnits={searchUnits}
                        setSelectedUnitName={setSelectedUnitName}
                        setSelectedSlots={setSelectedSlots}
                        setSlotRange={setSlotRange}
                    /> */}

                    {/* Table View for Units */}
                    {unitsLoading && currentPage === 1 && (!unitInfo || unitInfo.length === 0) ? (
                        <Loader />
                    ) : unitInfo && Array.isArray(unitInfo) && unitInfo.length > 0 ? (
                        <div className={styles.unitsTableWrapper}>
                            <table className={styles.unitsTable}>
                                <thead>
                                    <tr>
                                        <th>Sr. No.</th>
                                        <th>Unit Name</th>
                                        <th>Building Name</th>
                                        <th>Price</th>
                                        <th>Size</th>
                                        <th>Beds</th>
                                        <th>Baths</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {unitInfo.map((item: any, index: number) => {
                                        const isLastElement = index === unitInfo.length - 1;

                                        const getAssignedLockers = (unit: any) => {
                                            const uniqueLockers: string = [...new Set<number>(unit?.availability?.map((availItem: any) => availItem.locker))].join(',');
                                            return uniqueLockers;
                                        };

                                        const handleUnitClick = () => {
                                            if (item?.unit_status !== 'available') return;

                                            availabilityRedirectionContext?.setAvailabilityData((prevState: any) => {
                                                return {
                                                    ...prevState,
                                                    unitId: item.id,
                                                    lockerNumber: 1,
                                                    selectedDate: moment(new Date()).format('YYYY-MM-DD'),
                                                    slotRange: '',
                                                };
                                            });
                                            availabilityRedirectionContext?.setSelectedSlotsIndex([]);
                                            setSelectedSlots([]);
                                            setSlotRange('');
                                            availabilityRedirectionContext?.setStep(3);
                                            setSelectedUnitName(item.name || item.unitName);
                                            setSelectedUnit(item.id);
                                            setEnable(true);
                                            dispatch(getUnit(item.id));
                                            setAppointmentStep(appointmentStep + 1);
                                            availabilityRedirectionContext?.setLocationDetails?.((prevState: any) => {
                                                return {
                                                    ...prevState,
                                                    lockerNumber: getAssignedLockers(item)
                                                        ? getAssignedLockers(item).split(',').filter(Boolean)
                                                        : [],
                                                };
                                            });
                                        };

                                        return (
                                            <tr
                                                key={item.id || index}
                                                ref={isLastElement ? (lastElementRef as any) : null}
                                                className={`${styles.tableRow} ${item?.unit_status !== 'available' ? styles.disabledRow : styles.clickableRow}`}
                                                onClick={handleUnitClick}
                                            >
                                                <td>{index + 1}</td>
                                                <td>
                                                    <div className={styles.unitNameCell}>
                                                        <span className={styles.unitId}>
                                                            <span>{item?.unitYardiId || item?.name || item?.unitName || 'N/A'}</span>
                                                            {item?.integrationVendor === null && (
                                                                <Tooltip text='Manually created' variant='green' position='top'>
                                                                    <span className={styles.badge}>M</span>
                                                                </Tooltip>
                                                            )}
                                                            {getAssignedLockers(item) && <span className={styles.badge}>
                                                                <KeyLockerIcon size={16} /><span>{getAssignedLockers(item)}</span>
                                                            </span>}
                                                            {/* {getAssignedLockers(item) && <span className={styles.badge}>{getAssignedLockers(item)}</span>} */}
                                                        </span>
                                                        {(item?.nickName || item?.nickname) && (
                                                            <span className={styles.unitNickname}>
                                                                &quot;{item?.nickName || item?.nickname}&quot;
                                                            </span>
                                                        )}

                                                    </div>
                                                </td>
                                                <td>
                                                    {item.buildingName || item.buildingName || '-'}
                                                </td>
                                                <td>
                                                    {item.price || item.unitPrice ? (
                                                        <span className={styles.price}>${item.price || item.unitPrice}</span>
                                                    ) : (
                                                        <span className={styles.noPrice}>—</span>
                                                    )}
                                                </td>
                                                <td>
                                                    <span className={styles.size}>
                                                        {item.size || item.unitSize || 0} Sq Ft
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className={styles.beds}>
                                                        {+item.rooms ?
                                                            Number(item.rooms) === 0
                                                                ? 'Studio'
                                                                : `${Number(item.rooms)} ${Number(item.rooms) === 1 ? 'Bed' : 'Beds'}` : '-'}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className={styles.baths}>
                                                        {item.baths ? `${+item.baths} ${+item.baths === 1 ? 'Bath' : 'Baths'}` : '-'}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span
                                                        className={`${styles.statusBadge} ${item?.unit_status === 'available'
                                                            ? styles.statusAvailable
                                                            : item?.unit_status === 'occupied'
                                                                ? styles.statusOccupied
                                                                : styles.statusArchived
                                                            }`}
                                                    >
                                                        {item?.unit_status === 'occupied' ? 'Occupied' : item?.unit_status || 'N/A'}
                                                    </span>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                            {unitsLoading && currentPage > 1 && (
                                <div className={styles.loadingMore}>
                                    <TinyLoader />
                                </div>
                            )}
                        </div>
                    ) : !unitsLoading && currentPage === 1 && (!unitInfo || !Array.isArray(unitInfo) || unitInfo.length === 0) ? (
                        <div className={styles.noUnits}>
                            <img src={NoUnits} alt="no-units" />
                            <p className={styles.noUnitsFoundText}>No Units Available</p>
                        </div>
                    ) : null}
                </Fragment>
            ) : appointmentStep === 3 ? (
                <AppointmentDateTimePicker
                    setEnable={setEnable}
                    slotRange={slotRange}
                    setSlotRange={setSlotRange}
                    setSelectedDate={setSelectedDate}
                    selectedDate={selectedDate}
                    selectedUnit={selectedUnit}
                    setActiveTab={setActiveTab}
                    activeTab={activeTab}
                    setSpecificLockerData={setSpecificLockerData}
                    specificLockerData={specificLockerData}
                    setSelectedSlots={setSelectedSlots}
                    selectedSlots={selectedSlots}
                />
            ) : (
                <AppointmentConfirmation
                    userId={userId}
                    locationDetail={locationDetail}
                    slotRange={slotRange}
                    userData={userData}
                    selectedDate={selectedDate}
                    selectedUnit={selectedUnit}
                />
            )}

            {showModalPopup && (
                <CustModal
                    open={showModalPopup}
                    setOpen={() => setShowModalPopup(!showModalPopup)}
                    bodyData={
                        <AppointmentPopup
                            title={'Appointment has been booked!'}
                            message={'Appointment information has been sent to visitor on registered email address '}
                            setShowModalPopup={setShowModalPopup}
                        />
                    }
                    className="appointment-modal-popup"
                />
            )}
        </Fragment>
    );
}

export default VisitorAppointment;
